import React from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

const LANG_OPTIONS = [
  { code: 'pt_BR', label: 'Português', flag: '🇧🇷' },
  { code: 'en_US', label: 'English', flag: '🇺🇸' },
  { code: 'fr_FR', label: 'Français', flag: '🇫🇷' },
];

function normalizeToBackend(code: string): string {
  if (code.startsWith('pt')) return 'pt_BR';
  if (code.startsWith('en')) return 'en_US';
  if (code.startsWith('fr')) return 'fr_FR';
  return 'pt_BR';
}

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const current = normalizeToBackend(i18n.language || 'pt_BR');

  const changeLanguage = async (code: string) => {
    try {
      // Persist locally
      sessionStorage.setItem('lang', code);
      localStorage.setItem('lang', code);

      // Inform backend to set cookie (endpoint expects GET)
      await api.get(`/api/v2/lang/${code}`);

      // Update i18next without full reload
      await i18n.changeLanguage(code);
    } catch (e) {
      console.error('Failed to change language', e);
    }
  };

  return (
    <div className="relative">
      <select
        aria-label={t('Language')}
        className="appearance-none text-sm border border-gray-300 dark:border-gray-600 rounded-md px-2 pr-8 py-1 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        value={current}
        onChange={(e) => changeLanguage(e.target.value)}
      >
        {LANG_OPTIONS.map(opt => (
          <option key={opt.code} value={opt.code}>
            {opt.flag} {opt.label}
          </option>
        ))}
      </select>
      <svg
        className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  );
};

export default LanguageSwitcher;
